module.exports = __webpack_public_path__ + "static/media/16UNODC34.705929f4.jpg";